/**
 * @ignore
 * Created by daletan on 7/6/16.
 */

'use strict';

const loginActions = require('../actions/loginActions.es');
const currencyActionConstants = require('../constants/currencyActionConstants.es');

const UserStore = {
    storeName: 'UserStore',
    initialState: {
        isLoggedIn: false,
        canRequestNetPrice: false,
        fullProfile: null,
        currency: 'USD',
        isCurrencyLoaded: false,
        tradeSalesRep: null
    },
    reducers: {
        [loginActions.ACTION_NET_PRICE](state, { userCanRequestNetPrice }) {
            return Object.assign({}, state, {
                canRequestNetPrice: userCanRequestNetPrice
            });
        },
        [loginActions.ACTION_FULL_PROFILE](state, { profile }) {
            profile = profile || {};
            return Object.assign({}, state, {
                // convert the model to a json object so the backbone model is not stored
                fullProfile: typeof profile.toJSON === 'function' ? profile.toJSON() : profile,
                isLoggedIn: true
            });
        },
        [loginActions.ACTION_LOGGED_OUT_USER](state, { profile }) {
            profile = profile || {};
            return Object.assign({}, state, {
                // convert the model to a json object so the backbone model is not stored
                fullProfile: typeof profile.toJSON === 'function' ? profile.toJSON() : profile,
                isLoggedIn: false
            });
        },
        [loginActions.ACTION_TRADE_SALES_REP](state, { tradeSalesRep }) {
            return Object.assign({}, state, { tradeSalesRep });
        },
        [loginActions.ACTION_VIP_SALES_REP](state, { vipSalesRep }) {
            return Object.assign({}, state, { vipSalesRep });
        },
        /**
         * Set the user currency
         * @param state
         * @param currency
         * @returns {*}
         */
        [currencyActionConstants.CURRENCY_CHANGED](state, { currency }) {
            return Object.assign({}, state, {
                currency,
                isCurrencyLoaded: true
            });
        }
    },
    getters: {
        getNetPriceStatus: state => state.canRequestNetPrice,
        getFullProfile: state => state.fullProfile,
        getCurrency: state => state.currency,
        isCurrencyLoaded: state => state.isCurrencyLoaded,
        getTradeSalesRep: state => state.tradeSalesRep,
        getVipSalesRep: state => state.vipSalesRep
    }
};

module.exports = UserStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/UserStore.es.js